import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import {cn} from "components/RichEditor/lib/tiptap-utils";
import "components/RichEditor/components/tiptap-ui-primitive/dropdown-menu/dropdown-menu.scss";

function DropdownMenu({...props}) {
  return <DropdownMenuPrimitive.Root data-slot="tiptap-dropdown-menu" {...props} />;
}

function DropdownMenuPortal({...props}) {
  return (
    <DropdownMenuPrimitive.Portal data-slot="tiptap-dropdown-menu-portal" {...props} />
  );
}

function DropdownMenuTrigger({...props}) {
  return (
    <DropdownMenuPrimitive.Trigger data-slot="tiptap-dropdown-menu-trigger" {...props} />
  );
}

function DropdownMenuContent({className, align = "start", sideOffset = 4, ...props}) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        data-slot="tiptap-dropdown-menu-content"
        sideOffset={sideOffset}
        align={align}
        className={cn("tiptap-dropdown-menu-content", className)}
        onCloseAutoFocus={(e) => e.preventDefault()}
        {...props}
      />
    </DropdownMenuPrimitive.Portal>
  );
}

function DropdownMenuGroup({className, ...props}) {
  return (
    <DropdownMenuPrimitive.Group
      data-slot="tiptap-dropdown-menu-group"
      className={cn("tiptap-dropdown-menu-group", className)}
      {...props}
    />
  );
}

function DropdownMenuItem({className, inset, variant = "default", ...props}) {
  return (
    <DropdownMenuPrimitive.Item
      data-slot="tiptap-dropdown-menu-item"
      data-inset={inset}
      data-variant={variant}
      className={cn("tiptap-dropdown-menu-item", className)}
      {...props}
    />
  );
}

function DropdownMenuSub({...props}) {
  return <DropdownMenuPrimitive.Sub data-slot="tiptap-dropdown-menu-sub" {...props} />;
}

function DropdownMenuRadioGroup({...props}) {
  return (
    <DropdownMenuPrimitive.RadioGroup
      data-slot="tiptap-dropdown-menu-radio-group"
      {...props}
    />
  );
}

function DropdownMenuSubTrigger({className, inset, children, ...props}) {
  return (
    <DropdownMenuPrimitive.SubTrigger
      data-slot="tiptap-dropdown-menu-sub-trigger"
      data-inset={inset}
      className={cn("tiptap-dropdown-menu-sub-trigger", className)}
      {...props}
    >
      {children}
    </DropdownMenuPrimitive.SubTrigger>
  );
}

function DropdownMenuSubContent({className, ...props}) {
  return (
    <DropdownMenuPrimitive.SubContent
      data-slot="tiptap-dropdown-menu-sub-content"
      className={cn("tiptap-dropdown-menu-sub-content", className)}
      {...props}
    />
  );
}

export {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuGroup,
  DropdownMenuSub,
  DropdownMenuPortal,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuRadioGroup,
};
